// Relative Path: src\js\_lenis.js

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

class LenisScroll {
	constructor() {
		this.istance = new Lenis({
			duration: 1.2,
			easing: (t) => Math.min(1, 1.001 - 2 ** (-10 * t)),
			orientation: "vertical",
			gestureOrientation: "vertical",
			smoothWheel: true,
			wheelMultiplier: 1,
			infinite: false,
			autoRaf: false,
		});

		this.init();
	}

	init() {
		this.istance.on("scroll", ScrollTrigger.update);

		gsap.ticker.add((time) => {
			this.istance.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);
	}

	stop() {
		this.istance.stop();
	}

	start() {
		this.istance.start();
	}

	scrollTo(target, options = {}) {
		this.istance.scrollTo(target, options);
	}
}

const lenis = new LenisScroll();
export default lenis;
